<div class="counter-container" [ngClass]="[mode == 'vertical' ? 'vertical' : 'horizontal', customClass ? customClass : '']">
    <div class="counter-controls">
        <button class="left" (click)="decrement(); $event.stopPropagation()">-</button>
        <span (click)="openProductSelector(); $event.stopPropagation()">{{ article.quantity }}</span>
        <button class="right" (click)="increment(); $event.stopPropagation()">+</button>
    </div>
    <button *ngIf="showAdd" class="add-button" (click)="add(); $event.stopPropagation()">Add</button>
</div>
